import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableComponent, componentFrameworks } from './data-table.component';
import { AgGridModule } from 'ag-grid-angular';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DetailsComponent } from './columns/details/details.component';
import { ComplianceComponent } from './columns/compliance/compliance.component';
import { LunaCommonModule } from '../../common.module';
import { RouterLinkRendererComponent } from '../ag-grid/router-link-renderer.component';
import { ToolBarModule } from './tool-bar/tool-bar.module';
import { IconComponent } from './columns/icon/icon.component';
import { UrlComponent } from './columns/url/url.component';
import { RouterModule } from '@angular/router';

@NgModule({ declarations: [
        DataTableComponent,
        ComplianceComponent,
        IconComponent,
        UrlComponent
    ],
    exports: [
        ComplianceComponent,
        IconComponent,
        UrlComponent,
        DataTableComponent,
    ], imports: [CommonModule,
        ToolBarModule,
        AgGridModule,
        LunaCommonModule,
        RouterModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class DataTableModule { }
